import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "./ModalMessages.css";

export default class ModalMessage extends React.Component {
  closemodal = (response) => {
    this.props.cerrarBorrar(response);
  };

  render() {
    const { show, titulo, mensaje, bandera } = this.props;

    return (
      <Modal
        isOpen={!!show}
        centered
        toggle={() => this.closemodal(0)}
        className="mm-confirm-modal"
        contentClassName="mm-confirm-content"
      >
        <ModalBody className="mm-confirm-body">
          <div className="mm-confirm-header">
            <p><b>{titulo}</b></p>
          </div>

          <div className="mm-confirm-text">
            {bandera === "cambiarContrasena" ? (
              <p>
                Se enviarán las instrucciones al correo:
                <b>{" " + mensaje}</b>
              </p>
            ) : bandera === "deshabilitar" ? (
              <p>
                El producto <b>{mensaje}</b> se deshabilitará. ¿Desea continuar?
              </p>
            ) : bandera === "activar" ? (
              <p>
                El producto <b>{mensaje}</b> se activará. ¿Desea continuar?
              </p>
            ) : bandera === "deshabilitarLocacion" ? (
              <p>
                La locación <b>{mensaje}</b> se deshabilitará. ¿Desea continuar?
              </p>
            ) : bandera === "activarLocacion" ? (
              <p>
                La locación <b>{mensaje}</b> se habilitará. ¿Desea continuar?
              </p>
            ) : bandera === "desvincular" ? (
              <p>
                ¿Deseas <b>desvincular</b> <b>{mensaje}</b>?
              </p>
            ) : bandera === "cancelarFactura" ? (
              <p>
                La factura con Ticket <b>{mensaje}</b> se cancelará. ¿Desea continuar?
              </p>
            ) : bandera === "resolverReporte" ? (
              <p>
                El reporte se marcará como <b>resuelto</b>. ¿Desea continuar?
              </p>
            ) : (
              <p>
                ¿Deseas eliminar <b>{mensaje}</b>?
              </p>
            )}
          </div>

          <div className="mm-confirm-footer">
            <button
              className="mm-confirm-btn mm-confirm-cancel"
              onClick={() => this.closemodal(0)}
            >
              Cancelar
            </button>

            <button
              className="mm-confirm-btn mm-confirm-ok"
              onClick={() => this.closemodal(1)}
            >
              Continuar
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}